export const isEmpty = (array) => Array.isArray(array) && array.length === 0
export const isNotEmpty = (array) => !isEmpty(array)
export const arrayUniq = (array) => [ ...new Set(array) ]
export const generateSkeletonKeys = (size) => [ ...new Array(size) ].map((_, k) => `skeleton-key-${k}`)
